module.exports = __webpack_public_path__ + "img/jianada.15aac0a0.png";